import PageComponent from '/root/workspace/JiaMeiHuiBackstage_3hGC/src/pages/Journalism/index';

const PageComponentName = PageComponent;

export default PageComponentName;
